import Form from "./form";
import JustValidate from "just-validate";
import Swal from "sweetalert2";
import gsap from "gsap";
import "./popup";

// GLOBAL CLIENT-SIDE reCAPTCHA
window.recaptchaWidgetId = null;
window.recaptchaPromise = null;

window.recaptchaLoaded = false;

function loadRecaptcha() {
  if (window.recaptchaLoaded) return;

  window.recaptchaLoaded = true;

  if (!document.getElementById("global-recaptcha")) {
    const div = document.createElement("div");
    div.id = "global-recaptcha";
    div.style.display = "none";
    document.body.appendChild(div);
  }

  const script = document.createElement("script");
  script.src =
    "https://www.google.com/recaptcha/api.js?onload=onRecaptchaLoad&render=explicit";
  script.async = true;
  script.defer = true;
  script.setAttribute("data-cfasync", "false");

  document.body.appendChild(script);
}

window.onRecaptchaLoad = function () {
  window.recaptchaWidgetId = grecaptcha.render("global-recaptcha", {
    sitekey: "6LefSS4sAAAAABDAfq3cgLaEGHSNDcWTCccX5iEF",
    callback: window.onRecaptchaSuccess,
    "expired-callback": window.onRecaptchaExpired,
    "error-callback": window.onRecaptchaError,
  });
};

window.onRecaptchaSuccess = function () {
  document.getElementById("global-recaptcha").style.display = "none";

  if (window.recaptchaPromise) {
    window.recaptchaPromise.resolve();
    window.recaptchaPromise = null;
  }
};

window.onRecaptchaExpired = function () {
  if (window.recaptchaPromise) {
    window.recaptchaPromise.reject();
    window.recaptchaPromise = null;
  }
};

window.onRecaptchaError = function () {
  if (window.recaptchaPromise) {
    window.recaptchaPromise.reject();
    window.recaptchaPromise = null;
  }
};

window.waitForRecaptcha = function () {
  loadRecaptcha(); // load script only when needed

  document.getElementById("global-recaptcha").style.display = "flex";

  return new Promise((resolve, reject) => {
    window.recaptchaPromise = { resolve, reject };
  });
};

window.resetRecaptcha = function () {
  if (window.grecaptcha && window.recaptchaWidgetId !== null) {
    try {
      grecaptcha.reset(window.recaptchaWidgetId);
    } catch (e) {
      // fail silently – prevents console errors
      console.log("Error resetting reCAPTCHA:", e);
    }
  }
};
// GLOBAL CLIENT-SIDE reCAPTCHA

let footerCta = document.querySelector(".footer-cta");
let joinOurListForm = document.querySelector("#join-our-list");
const joinOurList = new JustValidate(joinOurListForm);

joinOurList.addField(joinOurListForm.querySelector('[name="Email"]'), [
  {
    rule: "required",
  },
  {
    rule: "email",
  },
  {
    validator: (value) => {
      let emailRegex =
        /^[a-zA-Z0-9](?:[a-zA-Z0-9._-]*[a-zA-Z0-9])?@[a-zA-Z0-9-]+(\.[a-zA-Z]{2,7})+$/;
      return emailRegex.test(value);
    },
    errorMessage: "Please Enter Valid Email Address",
  },
]);

joinOurList.onSuccess(async (event) => {
  try {
    const formData = new FormData(event.target);
    formData.append("Websitelink", window.location.href);
    formData.append("leadcreate", "leadcreate");
    footerCta.classList.add("send-data");
    let response = await fetch("/wp-content/themes/s2-labs/subscribeform.php", {
      body: formData,
      method: "POST",
    }).then((response) => {
      response.text().then((data) => {
        if (data.indexOf("Already") > 0) {
          Swal.fire({
            title: "Email Already Exists!",
            icon: "error",
            confirmButtonText: "OK",
          });
        } else if (data.indexOf("SUCCESS") >= 0) {
          Swal.fire({
            title: "You're Subscribed!",
            text: "Get ready for weekly drops of Salesforce updates, pro tips, career hacks, and exclusive learning resources delivered straight to your inbox.",
            icon: "success",
            confirmButtonText: "OK",
          });
        }
      });
    });
  } catch {
    Swal.fire({
      title: "Error!",
      text: "Something went wrong! Please try again after sometime...",
      icon: "error",
      confirmButtonText: "OK",
    });
  } finally {
    footerCta.classList.remove("send-data");
    joinOurListForm.reset();
  }
});

const registerNowForm = new Form(document.querySelector("#register-now-form"));

registerNowForm.validate.onSuccess(async (event) => {
  try {
    const formData = new FormData(event.target);
    formData.append("website-link", window.location.href);
    formData.append("course-title", formData.get("interested-course-static"));

    registerNowForm.modal.classList.add("loading");

    try {
      await waitForRecaptcha();
    } catch {
      registerNowForm.modal.classList.remove("loading");
      Swal.fire({
        title: "Error!",
        text: "Something went wrong! Please try again after sometime...",
        icon: "error",
        confirmButtonText: "Close",
      });
      return; // user did not verify captcha
    }

    let response = await fetch("/wp-content/themes/s2-labs/s2form.php", {
      body: formData,
      method: "POST",
    });

    if (!response.ok) throw Error("Something Went Wrong");

    Swal.fire({
      title: "Thank you!",
      text: "Please check your inbox, you will receive the e-mail with demo link shortly.",
      icon: "success",
      confirmButtonText: "Close",
    });
  } catch {
    Swal.fire({
      title: "Error!",
      text: "Something went wrong! Please try again after sometime...",
      icon: "error",
      confirmButtonText: "Close",
    });
  } finally {
    registerNowForm.modal.classList.remove("loading");
    registerNowForm.modal.querySelector("form").reset();
    registerNowForm.toggleModal();
    resetRecaptcha();
  }
});

// Footer list toggle
let footerDropDowns = document.querySelectorAll("footer .drop-bar");
footerDropDowns.forEach((footerDropDown) => {
  footerDropDown.addEventListener("click", () => {
    let footerListType = footerDropDown.dataset.list;
    let footerList = document.querySelector(
      `.couse-list[data-list="` + footerListType + `"]`,
    );
    if (footerList.classList.contains("hidden")) {
      footerList.classList.remove("hidden");
    } else {
      footerList.classList.add("hidden");
    }
    footerDropDown
      .querySelector(".drop-arrow")
      .classList.toggle("rotate-arrow");
  });
});

// newsletter popup
let NewsletterPopUp = document.getElementById("newsLetterPopUp");

let newsClose = NewsletterPopUp.querySelector(".closebtn");
newsClose.addEventListener("click", () => {
  gsap.to(".newsLetterPopUp", {
    translateX: "-100%",
    display: "none",
    ease: "power4.out",
    duration: 1,
  });
});
// newsletter popup

// newsletter form js
let NewsletterPopUpForm = document.querySelector("#newsLetterForm");
const loadingWindow = document.querySelector("#loading-window-popup");
const joinOurList_PopUp = new JustValidate(NewsletterPopUpForm);

joinOurList_PopUp.addField(
  NewsletterPopUpForm.querySelector('[name="Email"]'),
  [
    {
      rule: "required",
    },
    {
      rule: "email",
    },
    {
      validator: (value) => {
        let emailRegex =
          /^[a-zA-Z0-9](?:[a-zA-Z0-9._-]*[a-zA-Z0-9])?@[a-zA-Z0-9-]+(\.[a-zA-Z]{2,7})+$/;
        return emailRegex.test(value);
      },
      errorMessage: "Please Enter Valid Email Address",
    },
  ],
);

joinOurList_PopUp.onSuccess(async (event) => {
  try {
    const formData = new FormData(event.target);

    formData.append("Websitelink", window.location.href);
    formData.append("leadcreate", "leadcreate");
    formData.append("lsource", "Subscribe Form");
    loadingWindow.classList.add("show");
    NewsletterPopUpForm.classList.add("send-data");
    let response = await fetch("/wp-content/themes/s2-labs/subscribeform.php", {
      body: formData,
      method: "POST",
    }).then((response) => {
      response.text().then((data) => {
        if (data.indexOf("Technical Error") > 0) {
          Swal.fire({
            title: "Error!",
            text: "Something went wrong! Please try again after sometime...",
            icon: "error",
            confirmButtonText: "Close",
          });
          window.location.href =
            window.location.href + "?cachebuster=" + new Date().getTime();
          return false;
        }

        if (data.indexOf("Already") > 0) {
          Swal.fire({
            title: "Email Already Exists!",
            icon: "error",
            confirmButtonText: "OK",
          });
        } else if (data.indexOf("SUCCESS") >= 0) {
          Swal.fire({
            title: "Thanks for reaching us out!",
            text: "You're In! Thank You For Subscribing.",
            icon: "success",
            confirmButtonText: "OK",
          });
          document.querySelector(".newsLetterPopUp .closebtn").click();
        }
      });
    });
  } catch {
    Swal.fire({
      title: "Error!",
      text: "Something went wrong! Please try again after sometime...",
      icon: "error",
      confirmButtonText: "OK",
    });
  } finally {
    loadingWindow.classList.remove("show");
    NewsletterPopUpForm.classList.remove("send-data");
    NewsletterPopUpForm.reset();
  }
});
// newsletter form js

// stripe js for scrolling from bottom
// Uncomment the following lines to enable stripe scrolling functionality
document.addEventListener("scroll", () => {
  const stripe = document.querySelector(".event-stripe");
  if (window.scrollY > 100) {
    stripe ? stripe.classList.add("visible") : "";
  } else {
    stripe ? stripe.classList.remove("visible") : "";
  }
});

// dropup js
const dropupButtons = document.querySelectorAll(".dropup-button");

dropupButtons.forEach((button) => {
  button.addEventListener("click", (event) => {
    const dropupMenu = button.nextElementSibling;
    dropupMenu.classList.toggle("hidden");

    document.querySelectorAll(".dropup-menu").forEach((menu) => {
      if (menu !== dropupMenu) {
        menu.classList.add("hidden");
      }
    });
    event.stopPropagation();
  });
});

document.addEventListener("click", () => {
  document.querySelectorAll(".dropup-menu").forEach((menu) => {
    menu.classList.add("hidden");
  });
});
